import React, { useRef, useEffect } from 'react';

/**
 * Textarea component that dynamically adjusts its height based on its content scrollHeight.
 * Prevents horizontal scrolling and enables clean word wrapping.
 */
const AutoResizeTextarea = ({
  value,
  onChange,
  placeholder,
  className = '',
  style = {},
  rows = 1,
  ...props
}) => {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      style={{
        ...style,
        resize: 'none',
        overflowY: 'hidden',
      }}
      rows={rows}
      {...props}
    />
  );
};

export default AutoResizeTextarea;
